// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Block from "components/layout/Block";
import { TogglePreferences } from "./TogglePreferences";

// #####################################################
const AllowedNotifications = ({
	state,
	dispatch,
	userConsent,
	pushNotificationSupported,
	onClickAskUserPermission,
}) => {
	const { t } = useTranslation(["common", "userpanel"]);

	const requestForToken = (subscriptionOptions) => {
		return onClickAskUserPermission(subscriptionOptions);
	};

	// #####################################################

	return (
		<Block flex column>
			<TogglePreferences
				toggled={state.notificationsPlaySounds}
				dispatchAction={() =>
					dispatch({
						type: "SET",
						field: `notificationsPlaySounds`,
					})
				}
				text={t(
					"userpanel:settings.preferences.notifications.playSounds",
				)}
			/>
			<TogglePreferences
				toggled={state.notificationsDailySummary}
				dispatchAction={() =>
					dispatch({
						type: "SET",
						field: `notificationsDailySummary`,
					})
				}
				text={t(
					"userpanel:settings.preferences.notifications.dailySummary",
				)}
			/>

			{/* Pokazuj powiadomienia o wiadomościach w przeglądarce i aplikacji */}
			<TogglePreferences
				tooltipText={
					(!pushNotificationSupported || userConsent === "denied") &&
					t(
						"userpanel:settings.preferences.notifications.push.notificationsDisabledTooltip",
					)
				}
				toggled={state.pushMessagesNotifications}
				disabled={
					!pushNotificationSupported || userConsent === "denied"
				}
				dispatchAction={() => {
					if (!state.pushMessagesNotifications) {
						requestForToken()
							.then((res) => {
								if (res) {
									dispatch({
										type: "SET",
										field: "pushMessagesNotifications",
									});
								}
							})

							.catch(() => {});
					} else {
						dispatch({
							type: "SET",
							field: "pushMessagesNotifications",
						});
					}
				}}
				text={t(
					"userpanel:settings.preferences.notifications.push.messagesNotifications",
				)}
			/>

			{/* Pokazuj powiadomienia o innych zdarzeniach w przeglądarce i aplikacji */}
			<TogglePreferences
				tooltipText={
					(!pushNotificationSupported || userConsent === "denied") &&
					t(
						"userpanel:settings.preferences.notifications.push.notificationsDisabledTooltip",
					)
				}
				toggled={state.pushOtherNotifications}
				disabled={
					!pushNotificationSupported || userConsent === "denied"
				}
				dispatchAction={() => {
					if (!state.pushOtherNotifications) {
						requestForToken().then((res) => {
							if (res) {
								dispatch({
									type: "SET",
									field: "pushOtherNotifications",
								});
							}
						});
					} else {
						dispatch({
							type: "SET",
							field: "pushOtherNotifications",
						});
					}
				}}
				text={t(
					"userpanel:settings.preferences.notifications.push.otherNotification",
				)}
				noMarginBottom
			/>
		</Block>
	);
};

// #####################################################

export default AllowedNotifications;

// #####################################################
